export const banners = [
    `${process.env.PUBLIC_URL}/images/banner1.png`,
    `${process.env.PUBLIC_URL}/images/banner2.png`,
    `${process.env.PUBLIC_URL}/images/banner3.png`,
    `${process.env.PUBLIC_URL}/images/banner4.png`,
]